import React from 'react';
import { Layout, Card, Col, Row } from 'antd';
const { Content } = Layout;
import { checkMobile } from '../../comonFunction/utils'
const isMobile = checkMobile()
import MainContentSider from './MainContentSider'
import MainContentSright from './MainContentSright'
import MainContentCenter from '../pages/MainContentCenter'
import SinglePage from '../pages/MainContentCenter/SinglePage'

class MainContentSection extends React.Component {
    constructor(props){
        super(props)
    }
    state = {
        isMobile: ''
    }
    componentDidMount(){
        // console.log(this.props)
    }
    render(){
        return(
            <Content>
                <div
                    style={{
                        minHeight: '90vh',
                        background: '#fff',
                    }}
                >
                    <Row>
                        <Col xs={0} sm={0} md={0} lg={4} xl={4} style={{padding: '0px 3px 0px 3px'}}>
                            {/* <Card 
                                style={{borderRadius: '0px'}}
                                className=''
                                bordered={true}
                                hoverable={false}
                            >
                                <MainContentSider />
                            </Card> */}
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={14} xl={14}>
                            {this.props.isSingle?(<SinglePage {...this.props} onMyAccount={this.props.onMyAccount}/>):(<MainContentCenter  {...this.props} onMyAccount={this.props.onMyAccount}/>)}
                        </Col>
                        <Col xs={0} sm={0} md={0} lg={6} xl={6} style={{padding: '0px 3px 0px 3px'}}>
                            {/* <MainContentSright /> */}
                        </Col>
                    </Row>
                </div>
            </Content>
        )
    }
}

export default MainContentSection;